// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const TABLE_OF_CONTENTS = "Obsah";
